import React from "react";
import { useState } from "react";
import { responseHero } from "../../../utils/axiosInterceptor";
import { toast } from "react-toastify";
import { BlockchainSports, BlockchainSportsInstrument, RewardType } from "../../../models/blockchainsports/BlockchainSports";
import { genId } from "../../../utils/genId";

type ModalProps = {
    title: string;
    showModal: boolean;
    closeModal: () => void;
    handleStateChange: () => void;
    group_id: number;
    id: number;
    record: Pick<BlockchainSports, "group_id" | "quantity" | "node" | "dataStorageNode" | "id" | "BlockchainSportsReward"> | null;
}

type UIReward = {
    _clientId: string;
    instrumentType: BlockchainSportsInstrument;
    amount?: number;
    rewardType: RewardType;
};

type ModifiedPayload = Pick<BlockchainSports, 
"quantity" |
"node" |
"dataStorageNode" | 
"group_id" |
"id">

const EditBSModal = ({ title, showModal, closeModal, handleStateChange, group_id, id, record } : ModalProps) => {

    const [recordData, setRecordData] = useState<ModifiedPayload>({
        id: -1,
        quantity: 0,
        node: 0,
        dataStorageNode: 0,
        group_id: group_id || undefined,
    });

    React.useEffect(() => {
        setRecordData((prevState) => ({
            ...prevState,
            group_id: group_id || undefined,
        }));
    }, [group_id]) // only re-run the effect if group_id changes

    React.useEffect(() => {
        if(!id || !record) return;
        
        setRecordData({
            id: record.id,
            quantity: record.quantity,
            node: record.node,
            dataStorageNode: record.dataStorageNode,
            group_id: group_id || undefined,
        });

        setRewards(record.BlockchainSportsReward.map(r => ({
            _clientId: genId(),
            instrumentType: r.instrumentType,
            amount: r.amount === undefined || r.amount === null ? undefined : Number(r.amount),
            rewardType: r.rewardType,
        })));

    }, [id, record]);

    const handleChange = (
        type: keyof ModifiedPayload,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        let inputValue = e.target.value;
    
        setRecordData((prevData) => {
            return { ...prevData, [type]: Number(inputValue) || undefined };
        });
    }

    const makeRecord = async () => {

        if(!group_id) return toast.warn("Hiba a csoportazonosítóval, kérlek válassz ki csoportot!");
        if(!id) return toast.warn("Hiba az adatsor azonosítójával, kérlek próbáld újra!");

        await responseHero.put(`${process.env.REACT_APP_API_URL}/blockchainsports/${id}`, {
            record: {
              ...recordData,
              BlockchainSportsReward: rewards.map(r => ({
                instrumentType: r.instrumentType,
                amount: r.amount === undefined || r.amount === null ? undefined : Number(r.amount),
                rewardType: r.rewardType,
              })),
            }
          })
          .then((response) => {
            closeModal()
            handleStateChange();
            toast.success(`Sikeresen módosítottad az adatsort!`);
        }).catch(error => {
            console.error(JSON.stringify(error.response.data.message, null, 2));
            closeModal()
            toast.error(`Sikertelen adatrögzítés!`);
        })
    }

    const [rewards, setRewards] = useState<UIReward[]>([]);
    
    const addRewardRow = () => {
    setRewards((prev) => [
        ...prev,
        { _clientId: genId(), instrumentType: BlockchainSportsInstrument.USDT, amount: undefined, rewardType: RewardType.DIGITAL },
    ]);
    };
    const updateReward = <K extends keyof UIReward>(_clientId: string, key: K, value: UIReward[K]) => {
    setRewards((prev) => prev.map(r => r._clientId === _clientId ? { ...r, [key]: value } : r));
    };
    const removeRewardRow = (_clientId: string) => {
    setRewards((prev) => prev.filter(r => r._clientId !== _clientId));
    };

      
    return (
    <>
        {showModal && (
            <>
            <div className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative w-full my-6 mx-auto max-w-4xl">
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t">
                            <h3 className="text-xl text-brown font-semibold"><span className="text-dark-blue">BLOCKCHAIN SPORTS</span> - {title}</h3>
                        </div>
                        <div className="relative p-6 flex-auto">
                            <form>
                                <div className="flex p-2 rounded shadow-md">

                                    <div className="w-1/3 pr-2 text-center justify-center items-center">
                                        <label className="block text-sm font-bold mt-5 text-brown text-center justify-center" htmlFor="crypto_1">
                                            <span className="text-success">Blockchain Sports </span> <br/>ATLA mennyiség
                                        </label>
                                        <input
                                            type="number"
                                            inputMode="decimal"
                                            step="any"
                                            value={recordData?.quantity ?? ""}
                                            onChange={(e) => handleChange("quantity", e)}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                            placeholder=""
                                        />

                                    </div>

                                    <div className="w-1/3 pr-2 text-center justify-center items-center">
                                        <label className="block text-sm font-bold mt-5 text-brown text-center justify-center" htmlFor="crypto_1">
                                            <span className="text-success">Blockchain Sports </span> <br/>Csomópont
                                        </label>
                                        <input
                                            value={recordData?.node}
                                            onChange={(e) => handleChange('node', e)}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="name" type="text" placeholder=""/>
                                    </div>

                                    <div className="w-1/3 pr-2 text-center justify-center items-center">
                                        <label className="block text-sm font-bold mt-5 text-brown text-center justify-center" htmlFor="crypto_1">
                                            <span className="text-success">Blockchain Sports </span> <br/>Ebből adattárolást végzők
                                        </label>
                                        <input
                                            value={recordData?.dataStorageNode}
                                            onChange={(e) => handleChange('dataStorageNode', e)}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="name" type="text" placeholder=""/>
                                    </div>


                                    
                                </div>

                            </form>


                            <div className="mt-6">
                            <div className="mb-2 flex items-center justify-between">
                                <h4 className="text-base font-semibold">Jutalmak</h4>
                                <button
                                type="button"
                                onClick={addRewardRow}
                                className="rounded-lg bg-gray-900 text-white px-3 py-1.5 text-sm"
                                >
                                Jutalom hozzáadása
                                </button>
                            </div>

                            <div className="overflow-x-auto rounded-md border">
                                <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                    <th className="px-3 py-2 text-left text-xs font-semibold text-gray-700">Eszköz</th>
                                    <th className="px-3 py-2 text-left text-xs font-semibold text-gray-700">Összeg</th>
                                    <th className="px-3 py-2 text-left text-xs font-semibold text-gray-700">Típus</th>
                                    <th className="px-3 py-2 text-right text-xs font-semibold text-gray-700">Műveletek</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {rewards.length === 0 ? (
                                    <tr>
                                        <td className="px-3 py-3 text-sm text-gray-500" colSpan={4}>Nincs jutalom hozzáadva.</td>
                                    </tr>
                                    ) : rewards.map(r => (
                                    <tr key={r._clientId} className="hover:bg-gray-50">
                                        <td className="px-3 py-2 text-sm">
                                        <select
                                            className="w-full border rounded px-2 py-1"
                                            value={r.instrumentType}
                                            onChange={(e) => updateReward(r._clientId, "instrumentType", e.target.value as BlockchainSportsInstrument)}
                                        >
                                            {Object.values(BlockchainSportsInstrument).map(opt => (
                                            <option key={opt} value={opt}>{opt}</option>
                                            ))}
                                        </select>
                                        </td>
                                        <td className="px-3 py-2 text-sm">
                                        <input
                                            type="number"
                                            inputMode="decimal"
                                            step="any"
                                            className="w-full border rounded px-2 py-1"
                                            value={r.amount ?? ""}
                                            onChange={(e) => updateReward(r._clientId, "amount", e.target.value === "" ? undefined : Number(e.target.value))}
                                            placeholder=""
                                        />
                                        </td>
                                        <td className="px-3 py-2 text-sm">
                                        <select
                                            className="w-full border rounded px-2 py-1"
                                            value={r.rewardType}
                                            onChange={(e) => updateReward(r._clientId, "rewardType", e.target.value as RewardType)}
                                        >
                                            {Object.values(RewardType).map(opt => (
                                            <option key={opt} value={opt}>{opt}</option>
                                            ))}
                                        </select>
                                        </td>
                                        <td className="px-3 py-2 text-sm text-right">
                                        <button type="button" onClick={() => removeRewardRow(r._clientId)} className="rounded border px-2 py-1">
                                            Eltávolítás
                                        </button>
                                        </td>
                                    </tr>
                                    ))}
                                </tbody>
                                </table>
                            </div>
                            </div>
                        </div>

                        

                        <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                        <button
                            className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1"
                            type="button"
                            onClick={closeModal}
                        >
                            Mégse
                        </button>
                        <button
                            className="text-cream bg-dark-blue font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
                            type="button"
                            onClick={makeRecord}
                        >
                            Módosítás
                        </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-filter backdrop-blur-sm"></div>
            </>
        )}
    </>
  );
};

export default EditBSModal;